import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, EventEmitter, Output } from '@angular/core';
import { TranslateService } from "./Services/translate.service"
import { from, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ToastrService, IndividualConfig } from 'ngx-toastr';
import { coverdetails } from './Modules/travel/Modules/quote/Models/coverdetails';
import { QuotationDetails } from 'src/app/Modules/medical/modules/models/quotation-details.model';
import { environment } from 'src/environments/environment.prod';


@Injectable({ providedIn: "root" })
export class GlobalService {

  public messageEmitter = new EventEmitter()
  public headerEmitter = new EventEmitter();
  public showProgress = new EventEmitter();
  public medicalEmitter = new EventEmitter();
  public medicalFormResetEmitter = new EventEmitter();

  //Toaster
  options: IndividualConfig;
  
  public lang: any = [
    {
      name: "English",
      value: "en"
    },
    {
      name: "French",
      value: "fr"
    },
    {
      name: "Creole",
      value: "cr"
    }
  ]

  public errorMessage:string = "Operation Could not be Processed";
  public getlovrouting: string = "lov/all";
  public getmodellovrouting: string = "model/";
  public getbranchlovrouting: string = "branch/";
  
  
  //public Baseurl: string = environment.bohminhBaseUrl;   
  public Baseurl: string =window.location.origin+"/baominh/"
  public BaseDMSurl: string = this.Baseurl
  public BaseMedicalurl: string = this.Baseurl

  public UploadDMS:string = "/getDMSUpload/";
  public UploadDMSList:string = "/getDMSUploadList";
  public UploadDMSDelete:string = "/getDMSDelete";
  public UploadDMSView:string = "/getDMSView"; 
  public ClaimdmsNotification:string = "/getDmsClaimNotification/";
  public ClaimdmsView:string = "/getDmsClaimNotificationView";
  public Endorsementdmsupload:string = "/getDmsEndorsementsUpload/";
  public EndorsementdmsView:string = "/getDMSEndorsementView";
  public uploadStatus:string = "uploadStatus";
  public validFile:string="validFile";

  //for updating & delete the uploaded file in table 
  public updateUploadStatus ="updateUploadStatus";
  public deleteUploadStatus ="deleteUploadStatus";
  public deletefileuploadStatus ="uploadStatusdelete";
  public getViewUploadList ="getViewUploadListing";
  public getReqViewUploadList ="getReqViewUploadList";
  emailPattern: any = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$";



  

  public quoteNoForDMS:string = "";
  public claimNoForDMS:string = "";
  public endNoForDMS:string = "";
  public endpolicyNo:string = "";
  public uploadDocType:string = "";
  public policyNo:string = "";
  public preAuthViewClaimNo = "";
  public claimsysId = "";
  public claimIntViewClaimNo = "";
  
  public showArabic: boolean = false;
  public selectLang: string = "en"
  public JSONBaseurl: string = "assets/";
  public pageDir: string = "ltr";
  public pageContent: any = {};
  public menuContent: any = {};
  public commonContent: any = {};
  public showWhiteBanner: boolean = true;
  public loginStatus : boolean = false;
  public loginError : string = "";
  public agentName : any=[];
  public usertype : string =""; 
  public loginName :string="";
  public providerCode : any=[];
  public role : string =""; 
  public username :string=""; 
  //public currentMenu: number = 1;
  //public Baseurl: string = environment.baseURL;
  public currency: string = environment.CURRENCY; 
  public loginCont = false;
  public motorquoterouting: string = "quote";
  public calculatePremiumrouting: string = "calculatePremium";
  public loginRouting:string ="signin";
  public quoteListRouting ="quotelist";
  public idvValidationRouting ="idvValidation";
  public getCustomerDetailsRouting ="getCustomerDetails/";
  public calculatePremiumRouting ="calculatePremium";
  public getEndorsementTypes = "getSingleLOV/endorsementTypes/";
  public endorsementRequest = "endorsementRequest";
  public claimRequestWS = "claimIntimation";
  public renewalRequestWS = "renewalRequest";
  public getPolicyNumbers = "getSingleLOV/policyNoList/";
  public getClaimEventCode = "getSingleLOV/claimEventCode";
  public getClaimIntimationMode = "getSingleLOV/claimIntimationMode";
  public getrenewalPolicyNumbers = "getSingleLOV/renewalPolicyNoList/";
  public getIntimationPolicyDetails = "getIntimationPolicyDetails";
  public getFilterListingWS="listingFilter";
  public getListingWS="getListing";
  public preauthrequestlisting : string ="preauthrequestlisting";
  public claimintrequestlisting : string ="claimintrequestlisting";
  public preauthlistingView : string ="preauthlistingView";
  public claimIntlistingView : string = "claimIntlistingView";
  public preAuthRequestReport : string ="preAuthRequestReport";
 
  public convertToProposalRouting ="quotetoProposalConvert";
  public regValidationrouting :string = "regValidation";
  public chassisValidationrouting :string = "chassisValidation";
  public engValidationrouting :string ="engValidation";
  public getQuoteDetailsRouting:string="getQuoteDetails";
  public getProposalListingRouting:string="proposalList";

  public submitToUnderWritterRouting:string="submitToUnderwritter";
  public getPageLOVs="pageLOVs/";
  public getdepositAmount="depositAmount";
  public getModeOfPayments="ModeOfPayment";
  public getClaimSearchListWS="getClaimSearchList";
  public printscheduleRouting:string="printSchedule";
  public premiumComputationSheet:string="premiumComputationSheet";
  public userrouting :string ="submitusercreation";
  public useredit :String ="userCreationEdit";
  public agentListingWS = "agentListing";
  public changeRouting ="resetpassword";
  public useridValidationrouting ="useridValidation";
  public forgotpasswordrouting ="forgotpassword";
  public userListingWS ="userListing";
  public adminuploadWS ="adminupload";
  public coverDeailsRouting ="getCoverDetails";
  public addOnCoversRouting ="saveAddOnCovers";
  public reCalculateRouting="reCalculate";
  public getLOVByTypes = "getLOVByTypes/";
  public getLOVByType ="getusageType/";
  public getLOV = "getlov";

  public uploadListingWS ="uploadListing";
  public promotionuploadWS ="promotionupload";
  public getUploadedFiles ="getUploadedFiles/";
  public contactWS ="sendMessage";
  public promotionListingWS ="promotionListing";
  public getfleetupload ="getFleetUpload";
  public editQuoteDetailsRouting="editQuoteDetails";
  public downloadWS= "download";
  public editUserDetailsRouting ="editUserDetails";
  public notificationRouting ="pushnotification";
  public getDashboardChartRouting = "getDashboardChart/";
//ADDED BY DURGA FOR TRAVEL & SESSION TIME
  public coverList:Array<coverdetails> = [];
  public cover:any[] = [];
  public time = 0;
  public riskCount = 1;
  public firesmiCount = 0;
  public GAsmiCount = 0;
  public mandatoryFileTypes:any[] =[];
//END
  public message : string = "";
  public type :string ="";
  public counts  = 0;
  public messageRouting = "getmessage";
  public notificationListingWS = "getNotificationList";
  public notifiyRouting = "getNotificationCount";
  public remarksviewedRouting = "viewNotification";
  public ViewednotificationListingWS = "getViewedNotificationList";
  public usercreationeditrouting = "userCreationEdit";
  public requestPolicyrouting = "proposalToPolicyConvert";
  public productListingWS ="productlist";
  public getintimationregisternodetails = "getintimationregisternodetails";
  public getfleetlist ="getFleetListing";
  public getScheduleDetails="getScheduleDetails";
  public deletFile ="deleteFile";
  public fileListingWS ="fileTypeList";
  public updateProfile = "updateUserProfile";
  public viewprofile = "viewProfile";
  public getloginusers ="getLoginUsers";
  public generatepin = "pinGeneration";
  public pinListingWS = "getPinListing";
  public getuserType = "getUserType";
  public getCustomerDetailsRout ="getCustomerDetail/";
  public getLangSetup ="languageSetup"
  public checkedDetails ="getCheckedValues";
  public getvaluechange ="languageSetupChange";
  public sessionRouting ="sessionTiming";
  public sessiontime= "setTime";
  public reCalculateTravel ="reCalculateTravel";
  public getQuoteDetailstravel = "getQuoteDetailstravel";
  public sessiondetail ="sessionDetails";
  public editQuoteDetailsTravel ="editQuoteDetailsTravel";
  public coverdetailtravel ="getCoverDetailsTravel";
  public getPolicyChartRouting = "getPolicyChart";
  public coverlistrouting ="addRiskCovers";
  public chartlistingrouting ="ChartListing";
  public getdashboardChart ="dashboardChartSave";
  public getSelectedChartsRouting ="selectedCharts";
  public getchartEdit = "editChart";
  public getpolicyDetailsWS ="getPolicyDetails";
  public productDescritionrouting ="getProductDescription";
  public installmentrouting="getInstallBreakup";
  public faqdescrouting = "getFaqdesctiption";
  public LockQuoteDetails ="lockCsrQuote";
  public fileListingtravel = "fileTypeListtravel";
  public unlockQuote ="unlockCsrQuote";
  public getpasswordcrdate = "getUserCreateddate";
  public getpasswordexpmail ="getPasswordExpirymail";
  public transactionDetails = "getTransactiondetails";
  public getheaderdetails ="getHeaderSysid";
  public policyDetails ="getPolicydetails";
  public getstdPolicydetails ="getStandPolicydetails";
  public insertpaymentDetails ="insertPaymentdetails";
  public insertExcecssDetails="insertExcessdetails";
  public receiptDetails ="getReceiptDetails";
  public approvalmatrixDetails ="getApprovematrixresult";
  public getPremiumAmtEdit ="getPremiumAmtTravel";
  public getListingChartsRouting = "getListingChart";
  public getreceiptPolicyDetails ="getReceiptPolicyDetails";
  public getreceiptMedPolicyDetails ="getReceiptMedPolicyDetails";
  public getreceiptCustomerDetails ="getreceiptCustomerDetails";
  public getaccountdetails ="getBankAccountDetails";
  public saveReceiptDetails ="saveReceiptHeadeDetails";
  public receiptscreenDetail ="getReceiptSreenDetails";
  public receiptMedscreenDetail ="getReceiptMedInstallment";
  public getMedCustomerData ="PolicyDetails";
  public getReceiptDeposit ="ReceiptDeposit";
  public getReceiptApprove ="ReceiptApproval";
  public notificationlistingrouting ="getNotificationListing";
  public submitresponse ="submitNotifyResponse";
  public updatePolicyDetails ="updateAdjustmentAmt";
  public updateStandPolicyDetails = "updateStandAdjustmentAmt";
  public deleteStdPolicyDtls ="deleteStdPolicyDtls";
  public usercreationsms ="usercreationSMS";
  public getprodlist ="getImageProdList";
  public adminimgupload ="adminImgUpload";
  public getimageuploadlist ="getImageUploadlist";
  public viewImg = "viewUploadImg";
  public getuploadList ="getuploadfileList";
  public verifyUploadDocument ="verifyUploadedDocument";
  public validateUsername ="validateUsername";
  public getReceiptlisting="csrReceiptlisting";
  public updateQuoteToPolNo ="updateQuoteToPolNo";
  public getCSRDashboardChartsRouting = "getCSRDashboardChart";
  public getcsrpolicyDetails ="getCSRPolicyDetails";
  public emailidValidation ="validateEmailid";
  public exceptionDetails = "exceptionPolicyStatus";
  public updateExceptionDtls ="UpdateExceptionStatus";
  public getExceptionStatus = "getExceptionPolStatus";
  public getNoofdays ="getNoofDays";
  public vehicleValidation = "vehicleValidation";
  public submitNotes ="SaveNotes";
  public getdata ="getdata";
  public insertpaymentDetailsAdv ="insertpaymentDetailsAdv";
  public getInstlType = "getInstlType";
  public generateReceipt ="generateReceipt";
  public getAdvReceiptlisting ="getAdvReceiptlisting";
  public saveProposalDtls="saveProposalDtls";
  public getProposaldtls ="getProposaldtls";
  public receiptdtlsSave ="updateReceiptHeader";
  public leadCreation ="leadCreation";
  public getbranchdetails = "getBranchDetails";
  public getCollectionDetails = "getCollectionDetails";
  public saveBankdetails = "submitBankDetails";
  public getBankdtls = "getBankdtls";
  public verifyBankDetails = "verifyBankDetails";
  public serviceRequest = "saveServiceRequest";
  public serviceReqListing ="serviceReqListing";
  public requestUpload ="quoteRequestUpload";
  public downloadReqWS ="downloadRequest";
  public getQuestions ="getQuestions";
  public submitQuestion ="submitQuestion";
  public getQuestionsData ="getQuestionsData";
  public verifyProposalQuestDtls ="verifyProposalQuestDtls";
  public getUsageType = "getUsageType";
  public userNamechange = "getUserNameType";
  public getPayType ="getPayType";
  ////////////////// MEDICAL //////////////////////
    public receiptPrint = 'IndividualReceiptPrint'
  public medicalURL = this.Baseurl
  public bohminhURL = this.Baseurl

  public uploadPageURL = this.Baseurl

  // USER ROLE
  public _user_mode: string = null;
  public memberEmit = new EventEmitter();
  public coverEmit = new EventEmitter();
  public planDetails:any = [];

  // COMMMON
  public reviewQuote: any = {}
  public userData: any = null
  public alphaNumberPattern = /^[a-zA-Z0-9]*$/
  public NumberPattern = /^[0-9]*$/
  public nicNumberPattern = /^[a-zA-Z]{1}[0-9]{6}[a-zA-Z0-9]{7}$/

  // BUY POLICY
  public businessrouting: string = "natureOfBusiness?lang="
  public cityrouting: string = "city?lang="
  public loginrouting: string = "signin?lang="
  public getProductListRouting: string = "product/"
  public getPlanRouting: string = "plan"
  public getBenefitsRouting: string = "benefitsandsub?"
  public getQuote: string = "quotation?lang="
  public getCategory: string = "category?lang="
  public sendReview: string = "review"
  public customer: string = "customer"
  public question: string = "questions"
  public sentActuary: string = "actuary"
  public coverlist: string = "cover/"

  // BUY POLICY VARIABLE
  public selectedCategory: any = {}
  public ageslab: string = "ageslab"

  // QUOTATION
  public quotationlisting: string = "quotations"
  public quotationDetail: string = "quotation?quoteNo="
  public dobByNicId: string = "DOBByNicId?nicId="

  // POLICY
  public policylisting: string = "policy?brokerCode="
  
  public policies: string = "policies?brokerCode="
  public medicalpolicyview:string="medicalpolicyview";
  // ENDORSEMENT
  public endorsement: String = "endorsement"

  // CLAIM
  public claimlisting: string = "claims"
  public claimRequest:string = "claimRequest"
  public preauthrequest:string ="preauthrequest"

  public claimintimationrequest:string ="claimintimationrequest"


  public getMembers: string ="getMembers"
  public getprovider:string ="getprovider"
  public getpolicybymembership:string="getpolicybymembership"
  public getbenifit:string="getbenifit"
  public getBenefits: string = "benefits"
  public getPolicyNumber: string = "getPolicy"

  // UPLOAD DOCUMENT
  public medicalDocumentType : string = "meduploadlist"
  public medicalViewDocument : string = "meddmsview"
  public medicalDeleteDocument : string = "meddmsdelete"
  public medicaldmsupload : string = "meddmsupload"
  public payMedical: string = "policy";
  public updateCustomerCode : string = "updatemedcustomer" 
  public getdiagnosis : string ="getdiagnosis"
  
  // QUESTIONNARIE
  public medicalstdCase:any = "";

  // RENEWAL
  public renewalListing: string = "renewal"

  @Output() quoteDetails: EventEmitter < any > = new EventEmitter();

  /* NEW FLOW START */

  public proposal: QuotationDetails = new QuotationDetails()
  public medicalFlow: string = ""
  public typeUrl="chequeType"
  public review: boolean = false
  public prodCode: string = ""
  public receiptID:number=1
  /* NEW FLOW  END */
  

  ///////////////// MEDICAL ///////////////////

  constructor(private translate: TranslateService, private router: Router, private toastr : ToastrService) {
   // Toaster Started
    this.options = this.toastr.toastrConfig;
    this.options.positionClass = 'toast-top-center';
    this.options.timeOut = 1500;
  // Toaster Ended
  }

  // Toaster Started
  showToast(title, message, type) {
    this.toastr.show(message, title, this.options, 'toast-' + type);
  }
 // Toaster Ended

 
  GotoPage(page) {
    this.router.navigate([page]);
  }
  loadPage(page) {
    if (this.router.url.includes("profilesettings")) {
      this.router.navigate(["dashboard"]);
    } else {
      this.router.navigate([page]);
    }
  }
  

  loadPageContent(url: string) {
    this.pageContent = this.translate.data["home"];
    this.menuContent = this.translate.data["menu"];
    this.commonContent = this.translate.data["commonmessage"];
    for (let obj in this.translate.data) {
      
      if (String(url).toLowerCase().indexOf(obj.toLowerCase()) != -1) {
        this.pageContent = this.translate.data[obj];
        console.log("this.pageContent",url,this.pageContent);
        break;
      }
    }
  }

  resetFormData(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      //console.log(key, formGroup.controls[key],formGroup.controls[key]["controls"])

      if (formGroup.controls[key] instanceof FormGroup) {
        this.getFormValidationErrors(formGroup.controls[key] as FormGroup)
      } else if (formGroup.controls[key] instanceof FormArray) {

        let arr: FormArray = formGroup.controls[key] as FormArray;
        for (let id = 0; id < arr.controls.length; id++) {
          this.getFormValidationErrors(arr.controls[id] as FormGroup)
        }

      } else if (formGroup.controls[key] instanceof FormControl) {
        // formGroup.get(key).reset();
        // formGroup.get(key).setValidators([Validators.required]);
        // formGroup.get(key).updateValueAndValidity();
        //  formGroup.get(key).setValidators(null)
        //  formGroup.get(key).setErrors(null)
        // setTimeout(()=>{
        //   formGroup.get(key).setValidators([Validators.required])
        // },100)
        
        //formGroup.get(key).setValue(null)
        //formGroup.get(key).markAsUntouched()

      }

    });
  }
  getFormValidationErrors(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      //console.log(key, formGroup.controls[key],formGroup.controls[key]["controls"])

      if (formGroup.controls[key] instanceof FormGroup) {
        this.getFormValidationErrors(formGroup.controls[key] as FormGroup)
      } else if (formGroup.controls[key] instanceof FormArray) {

        let arr: FormArray = formGroup.controls[key] as FormArray;
        for (let id = 0; id < arr.controls.length; id++) {
          this.getFormValidationErrors(arr.controls[id] as FormGroup)
        }

      } else if (formGroup.controls[key] instanceof FormControl) {
        //formGroup.get(key).setErrors(null)
        // if (controlErrors != null) {
        //   Object.keys(controlErrors).forEach(keyError => {
        //     console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        //   });
        // }
      }

    });
  }
}

